<template>
    <!-- ServiceNumberSearchItem.vue -->
    <base-search-item :to="numberUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {PRODUCTS_ICON} from '@/store/static/base-icons'
    import {CUSTOMER_NUMBER} from '@/router/customer/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'ServiceNumberSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The list item icon
             */
            icon: {
                type: String,
                default: PRODUCTS_ICON
            }
        },
        computed: {
            numberUrl () {
                const vm = this
                const [customerId, serviceNumber] = vm.item.id.split('_')

                return {
                    name: CUSTOMER_NUMBER,
                    params: {
                        customerId,
                        serviceNumber
                    }
                }
            }
        }
    }
</script>
